/**
 * /people/lifecycle-agent — Tashghil's employee + contract
 * lifecycle agent (Pack 5 v2).
 */

import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

export function EmployeeLifecycleAgentPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Employee Lifecycle Agent"
        subtitle="Tashghil drives hire / promote / transfer / suspend / terminate / rehire. Mutaba'aa watches Article 60 / 53 / 18."
      />

      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <AgentBadge agent="tashghil" />
          <h3 className="text-base font-semibold">Lifecycle events</h3>
        </div>
        <ul className="text-sm text-text-secondary space-y-1.5">
          <li><strong>Hired</strong> — Tashghil onboards; Mutaba'aa fires GOSI registration scan</li>
          <li><strong>Promoted</strong> — Tashghil orchestrates; Rawatib re-bases payroll</li>
          <li><strong>Transferred</strong> — Tashghil routes approvals; Mutaba'aa Article 18 succession check</li>
          <li><strong>Suspended</strong> — Mutaba'aa records disciplinary process audit</li>
          <li><strong>Reinstated</strong> — Tashghil reverses suspension; pay rules re-apply</li>
          <li><strong>Terminated</strong> — Tashghil opens M18 EOS; Mutaba'aa Article 80 checklist</li>
          <li><strong>Rehired</strong> — Tashghil checks Article 80 ban-list; M11 original_hire_date preserved</li>
        </ul>
      </section>

      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <AgentBadge agent="mutabaa" />
          <h3 className="text-base font-semibold">Contract amendments — 7 scopes</h3>
        </div>
        <ul className="text-sm text-text-secondary space-y-1.5">
          <li>Salary → Article 60 consent check</li>
          <li>Position → Article 18 / role-band sanity</li>
          <li>Probation → Article 53 cap (90 / 180 with consent)</li>
          <li>Facility flag → audit only</li>
          <li>Allowance override → Article 86 base check</li>
          <li>Term end → Article 88 settlement SLA</li>
          <li>Stop toggle → audit + Rawatib stop-accrual</li>
        </ul>
      </section>
    </div>
  );
}
